import React from "react";
import { Box, Heading, Text, HStack, VStack, Icon } from "@chakra-ui/react";
import { FaFileInvoiceDollar, FaMoneyCheckAlt } from "react-icons/fa";

const disclosureItems = [
  {
    title: "Swift Installment Loans",
    icon: FaFileInvoiceDollar,
    body: "We offer installment loans in the amount of $500 - $20,000 with a 12-60 month term and an APR of 19.99% - 30.99%. On $1,500 borrowed for a 1-year term at 2.6% per month, the total cost of borrowing is $464.85. The total amount to be paid back with interest is $1,964.85, and the monthly payment is $163.73.\n\nNB: You can pay off your installment loan at any time with no penalty. You will only pay interest up to the date you pay it off.",
  },
  /*{
    title: "Swift Small Cash Loans - Ontario, British Columbia, and Alberta Residents only",
    icon: FaMoneyCheckAlt,
    body: "We offer Swift small cash loans in the amount of $100 - $1,500. The cost of borrowing is $14.00 per $100.00 borrowed. On a $1,000.00 loan for 42 days, the cost of borrowing is $140.00. The total to pay back is $1,140.00, which is an annual percentage rate of 121.00%.\n\nThe loan must be paid in full by the end of the term, with no exceptions and no automatic renewals. Failure to pay your debt on time may impact your future credit with Swift Credit and other lenders. All delinquencies will be reported to the credit bureaus.",
  },*/
];

export default function Disclosurre() {
  return (
    <Box
      w="100%"
      bg="gray.50"
      py={{ base: 8, md: 10 }}
    >
      <Box maxW="1100px" mx="auto" px={{ base: 4, md: 8 }}>
        <Box border="1px solid" borderColor="gray.200" borderRadius="xl" p={{ base: 5, md: 6 }} bg="white" boxShadow="sm">
          <VStack spacing={2} textAlign="center" mb={5}>
            <Heading size="md">Disclosures</Heading>
          </VStack>

          <VStack spacing={4} align="stretch">
            {disclosureItems.map((item) => (
              <Box key={item.title} border="1px solid" borderColor="gray.200" borderRadius="lg" p={4} bg="gray.50">
                <HStack spacing={3} align="flex-start">
                  <Box
                    minW="38px"
                    h="38px"
                    borderRadius="full"
                    bg="blue.100"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Icon as={item.icon} color="blue.700" boxSize={4} />
                  </Box>
                  <VStack align="stretch" spacing={1}>
                    <Text fontWeight="700" color="gray.800" fontSize="sm">{item.title}</Text>
                    <Text color="gray.700" fontSize="sm" whiteSpace="pre-line">{item.body}</Text>
                  </VStack>
                </HStack>
              </Box>
            ))}
          </VStack>
        </Box>
      </Box>
    </Box>
  );
}
